var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-exam-wrap examChurchOwn" }, [
    _c(
      "div",
      { staticClass: "uni-exam-pay" },
      [
        _c(
          "div",
          { staticClass: "continer" },
          [
            _c("Title", { attrs: { text: "查看堂次" } }),
            _c(
              "div",
              { staticClass: "elTable" },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      slot: "list",
                      data: _vm.dataList,
                      headerRowClassName: "uni-primary-table-header",
                      stripe: "",
                      border: "",
                    },
                    slot: "list",
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "exam_course_title",
                        align: "center",
                        label: "课程名称",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "exam_hall_start_time",
                        align: "center",
                        label: "考试时间",
                        width: "350",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(scope.row.exam_hall_start_time) +
                                  " - " +
                                  _vm._s(
                                    scope.row.exam_hall_end_time.split(" ")[1]
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "exam_type",
                        align: "center",
                        label: "考试类型",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.course[scope.row.exam_type].name) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "考点" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._ENTRANCETYPE === "own" &&
                              scope.row.exam_type == 2
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "address",
                                      on: {
                                        click: function ($event) {
                                          return _vm.exam_address(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.exam_point_title) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "exam_status_text",
                        align: "center",
                        label: "状态",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "score", align: "center", label: "成绩" },
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", width: "200", label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.is_take_exam(scope.row)
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { "font-size": "12px" },
                                      attrs: { size: "small", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.startExam(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("开始考试")]
                                  )
                                : _c("span", [_vm._v("--")]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              width: "800px",
              title: "地址",
              visible: _vm.examInfoVisible,
            },
            on: {
              "update:visible": function ($event) {
                _vm.examInfoVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "dialog", staticStyle: { padding: "0 0 10%" } },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: [_vm.userInfo] },
                  },
                  [
                    _vm._ENTRANCETYPE === "own"
                      ? _c("el-table-column", {
                          attrs: { prop: "exam_point_title", label: "考点" },
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: { prop: "exam_room_teacher_sn", label: "考室" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                " 第" +
                                  _vm._s(row.exam_room_teacher_sn) +
                                  "考室 "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "exam_room_title", label: "教室" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "exam_room_seat_number",
                        label: "座位序号",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "exam_room_teacher_title",
                        label: "监考老师",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "exam_point_address", label: "详细地址" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.examInfoVisible = false
                      },
                    },
                  },
                  [_vm._v("知道了")]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }